import { ResponseError } from '@backstage/errors';

class AwsCostExplorerApiClient {
  configApi;
  identityApi;
  constructor(options) {
    this.configApi = options.configApi;
    this.identityApi = options.identityApi;
  }
  async getCostAndUsage(accountId, tagKey, tagValue, periodStart, periodEnd) {
    const queryString = new URLSearchParams();
    queryString.append("accountId", accountId);
    queryString.append("tagKey", tagKey);
    queryString.append("tagValue", tagValue);
    queryString.append("periodStart", periodStart);
    queryString.append("periodEnd", periodEnd);
    const urlSegment = `cost-and-usage?${queryString}`;
    const service = await this.get(urlSegment);
    return service;
  }
  async get(path) {
    const baseUrl = `${await this.configApi.getString(
      "backend.baseUrl"
    )}/api/aws-mini-cost-center-backend/}`;
    const url = new URL(path, baseUrl);
    const { token: idToken } = await this.identityApi.getCredentials();
    const response = await fetch(url.toString(), {
      headers: idToken ? { Authorization: `Bearer ${idToken}` } : {}
    });
    if (!response.ok) {
      throw await ResponseError.fromResponse(response);
    }
    return response.json();
  }
}

export { AwsCostExplorerApiClient };
//# sourceMappingURL=AwsCostExplorerApiClient.esm.js.map
